import styled from "@emotion/styled";

const SubmitButton = styled.button`
  width: 150px;
  height: 50px;
  border-radius: 5px !important;
  background-color: #B82E3C !important;
  border: none;
    height: 40px;
    color: #ffffff!important;
    cursor: pointer;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    line-height: 35px;
    background-color: #B82E3C;
    @media screen and (max-width:599px){
      text-align: center;
    }
    :focus{
      outline: none;
    }
`
const RegWrapper = styled.div`
  font-size: 25px;
  font-weight: 700;
  padding-top: 20px;
  `;
const RegFormName = styled.div`
  padding-bottom: 15px;
  color: #fff;
  @media screen and (max-width:599px){
    font-size: 20px;
    
  }
  `;
const RegFormInput = styled.input`
   background-color: #f5f9fc;
  border: 0;
  width: 100%;
  padding: 15px 0px 15px 15px;
  font-size: 20px;
  :focus{
  outline: 0px dotted !important;
  outline: 0px auto -webkit-focus-ring-color !important;
  }
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
  `;
  export{SubmitButton,RegWrapper,RegFormName,RegFormInput,Span,}